<template>
    <Dialog
        title="Edit Shipment Details"
        :open="open"
        @close="emit('close')"
    >
        <Field
            v-model="optionsForm.parcelLength"
            label="Parcel Length (in)"
            type="number"
            :error="optionsForm.errors.parcelLength"
        />

        <Field
            v-model="optionsForm.parcelWidth"
            label="Parcel Width (in)"
            type="number"
            :error="optionsForm.errors.parcelWidth"
        />

        <Field
            v-model="optionsForm.parcelHeight"
            label="Parcel Height (in)"
            type="number"
            :error="optionsForm.errors.parcelHeight"
        />

        <Field
            v-model="optionsForm.parcelOunces"
            label="Parcel Weight (oz)"
            type="number"
            :error="optionsForm.errors.parcelOunces"
        />

        <hr>

        <div class="is-width-100 is-flex is-justify-content-flex-end">
            <button
                class="button is-primary"
                :class="{
                    'is-loading': optionsForm.processing,
                }"
                @click.prevent="handleSave"
            >
                Save
            </button>
        </div>
    </Dialog>
</template>

<script setup lang="ts">
import Dialog from "@/Components/Dialog.vue";
import {FulfillmentOrder} from "@/Types/FulfillmentOrder";
import Field from "@/Components/common/Field.vue";
import {useForm} from "@inertiajs/vue3";

const props = defineProps<{
    open: boolean;
    fulfillmentOrder: FulfillmentOrder;
}>();

const emit = defineEmits<{
    (e: 'close'): void;
}>();

const optionsForm = useForm({
    parcelLength: props.fulfillmentOrder.parcelLength?.toString?.() ?? '',
    parcelWidth: props.fulfillmentOrder.parcelWidth?.toString?.() ?? '',
    parcelHeight: props.fulfillmentOrder.parcelHeight?.toString?.() ?? '',
    parcelOunces: props.fulfillmentOrder.parcelOunces?.toString?.() ?? '',
});

function handleSave() {
    optionsForm.post(route('admin.self_fulfillment.orders.set_shipping_options', {fulfillmentOrder: props.fulfillmentOrder.id}), {
        onSuccess() {
            emit('close');
        },
    })
}
</script>
